import { forwardRef } from 'react';
import { styled } from 'goober';

import { colors } from '@/theme/colors';
import type { Variant } from '@/ui/button/button';
import { Button } from '@/ui/button/button';
import type { IconVariant } from '@/ui/icons/icon';

export interface UploadFileInputProps {
  variant?: Variant;
  acceptedFiles: string[];
  buttonText?: string;
  onUploadFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
  multiple?: boolean;
  icon?: IconVariant;
}

export const UploadFileInput = forwardRef<
  HTMLInputElement,
  UploadFileInputProps
>(function UploadFileInput(
  {
    acceptedFiles,
    variant,
    buttonText,
    onUploadFile,
    onClick,
    multiple,
    icon = 'ArrowDownFromBracket',
  },
  fileInputRef,
) {
  return (
    <>
      <input
        name="new-file"
        type="file"
        onChange={onUploadFile}
        multiple={multiple}
        ref={fileInputRef}
        accept={acceptedFiles.map(file => `.${file}`).join(',')}
        hidden
      />
      <UploadButton
        variant={variant ?? 'text'}
        startIcon={icon}
        color={!variant ? colors.blue.primaryA : undefined}
        onClick={onClick}
      >
        {buttonText}
      </UploadButton>
    </>
  );
});

const UploadButton = styled(Button)`
  height: fit-content;
`;
